import React from 'react';
import Script from 'next/script';
import getConfig from 'next/config';

interface GoogleMapsScriptTagProps {
  callback?: string;
  onLoad?: () => void;
  strategy?: 'afterInteractive' | 'beforeInteractive' | 'lazyOnload';
}

const GoogleMapsScriptTag: React.FC<GoogleMapsScriptTagProps> = ({
  callback = null,
  strategy = 'afterInteractive',
  onLoad,
}) => {
  const { GOOGLE_MAPS_WEB_KEY } = getConfig().publicRuntimeConfig;

  const callbackSuffix = callback ? `&callback=${callback}` : '';

  return (
    <Script
      key="google-maps-script"
      strategy={strategy}
      onLoad={onLoad}
      src={`https://maps.googleapis.com/maps/api/js?libraries=places,geometry&loading=async&key=${GOOGLE_MAPS_WEB_KEY}${callbackSuffix}`}
    />
  );
};

export default GoogleMapsScriptTag;
